export const bgTypes = [
	{ label: 'Solid', value: 'solid' },
	{ label: 'Gradient', value: 'gradient' },
	{ label: 'Image', value: 'image' },
];

export const attachments = [
	{ label: 'Initial', value: 'initial' },
	{ label: 'Scroll', value: 'scroll' },
	{ label: 'Fixed', value: 'fixed' },
	{ label: 'Local', value: 'local' },
];

export const repeats = [
	{ label: 'No Repeat', value: 'no-repeat' },
	{ label: 'Repeat', value: 'repeat' },
	{ label: 'Repeat X', value: 'repeat-x' },
	{ label: 'Repeat Y', value: 'repeat-y' },
];

export const sizes = [
	{ label: 'Cover', value: 'cover' },
	{ label: 'Auto', value: 'auto' },
	{ label: 'Contain', value: 'contain' },
];